module.exports = "/_next/static/images/zm-53783063b6ae78cd142f0763a2a846cf.svg";